module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CC - Cocos (Keeling) Islands.44d948cd.svg";